import {ToastContainer} from 'react-toastify';
import AppRoutes from './AppRoutes';
import {ResourceAllocationProvider} from './resource_allocation/context/ResourceAllocationContext.tsx';
import {SignalRProvider} from './contexts/SignalRContext';
import {PersonContextProvider} from './contexts/PersonContextProvider';
import 'react-contexify/dist/ReactContexify.css';

function App() {
    return (
        <SignalRProvider>
            <PersonContextProvider>
                <ResourceAllocationProvider>
                    <ToastContainer />
                    <AppRoutes />
                </ResourceAllocationProvider>
            </PersonContextProvider>
        </SignalRProvider>
    );
}

export default App;
